const initialState = {
  userDetails: null,
  portfolio:[],
  portfolioItem:null,
  currentLang: { lang: 'ar', id: 1 }
};
export default initialState;
